// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .filter-container {
  top: 6px !important;
}

::ng-deep .p-table {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: unset !important;
  max-height: 100%;
  min-height: 100%;
}

::ng-deep .p-table .p-table-caption {
  flex: 0 0 auto;
  height: 56px;
  padding-left: 6px;
}

::ng-deep .p-treetable .p-treetable-caption {
  padding: 6px 6px 10px 6px;
  height: 56px;
}

::ng-deep .p-table .p-table-scrollable-wrapper {
  flex: 1 1 auto;
  display: flex;
  height: inherit;
  overflow: auto;
  max-height: 100%;
}

:host .layout {
  height: calc(80vh - 20px);
  min-height: 100%;
  max-height: 100%;
  display: flex;
  flex: 1 1;
  flex-direction: column;
}
:host header, :host footer {
  flex: 0 0 56px;
}
:host footer div {
  text-align: right;
  padding: 0.8em;
}
:host footer in-button {
  margin-left: 1em;
}
:host .content {
  flex: 1 1 auto;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
